import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IntakeStatus } from 'api';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'comp-intake-state-pill',
  templateUrl: './intake-state-pill.component.html',
  styleUrls: ['./intake-state-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class IntakeStatePillComponent {
  readonly status = input.required<IntakeStatus>();
  readonly size = input<'default' | 'compact'>('default');

  protected readonly labelKey = computed(() => {
    return `requirementIntake.status.${this.status()}`;
  });

  protected readonly pillClass = computed(() => {
    const sizeClass =
      this.size() === 'compact' ? 'intake-state-pill-compact' : 'intake-state-pill-default';

    switch (this.status()) {
      case IntakeStatus.Decided:
        return `intake-state-pill intake-state-pill-decided ${sizeClass}`;
      case IntakeStatus.NotApplicable:
        return `intake-state-pill intake-state-pill-not-applicable ${sizeClass}`;
      case IntakeStatus.ReviewFindings:
        return `intake-state-pill intake-state-pill-review-findings ${sizeClass}`;
      case IntakeStatus.PendingAnalysis:
        return `intake-state-pill intake-state-pill-analyses-pending ${sizeClass}`;
      default:
        return `intake-state-pill intake-state-pill-todo ${sizeClass}`;
    }
  });
}
